module.exports = __webpack_public_path__ + "img/placeholder.b58ec7db.svg";